import React from 'react';
import Icon from '../../../components/AppIcon';

const MarketExpansionAnalysis = ({ customers }) => {
  const analysisMetrics = [
    {
      title: 'Kapasitas Akuisisi Pelanggan',
      value: customers?.length < 10 ? 'Tinggi' : customers?.length < 20 ? 'Sedang' : 'Rendah',
      description: 'Kemampuan untuk menambah pelanggan baru',
      icon: 'UserPlus',
      color: customers?.length < 10 ? 'text-success' : customers?.length < 20 ? 'text-warning' : 'text-error'
    },
    {
      title: 'Fleksibilitas Harga',
      value: customers?.some(c => c?.paymentTerms === 'Cash') ? 'Baik' : 'Terbatas',
      description: 'Kemampuan negosiasi harga dengan pelanggan',
      icon: 'DollarSign',
      color: customers?.some(c => c?.paymentTerms === 'Cash') ? 'text-success' : 'text-warning'
    },
    {
      title: 'Stabilitas Kontrak',
      value: customers?.filter(c => c?.contractDuration?.includes('tahun'))?.length > customers?.length / 2 ? 'Stabil' : 'Tidak Stabil',
      description: 'Kekuatan hubungan kontraktual',
      icon: 'FileText',
      color: customers?.filter(c => c?.contractDuration?.includes('tahun'))?.length > customers?.length / 2 ? 'text-success' : 'text-warning'
    },
    {
      title: 'Diversifikasi Tipe',
      value: new Set(customers.map(c => c.type))?.size >= 3 ? 'Terdiversifikasi' : 'Terkonsentrasi',
      description: 'Keberagaman tipe pelanggan',
      icon: 'PieChart',
      color: new Set(customers.map(c => c.type))?.size >= 3 ? 'text-success' : 'text-warning'
    }
  ];

  const marketOpportunities = [
    {
      opportunity: 'Ekspansi Retail Modern',
      potential: 'Tinggi',
      description: 'Peluang kerjasama dengan supermarket dan minimarket',
      icon: 'ShoppingCart'
    },
    {
      opportunity: 'Program Institusi Pendidikan',
      potential: 'Sedang',
      description: 'Kontrak susu sekolah dan universitas',
      icon: 'GraduationCap'
    },
    {
      opportunity: 'Kemitraan Korporat',
      potential: 'Tinggi',
      description: 'Penyediaan susu untuk kantin perusahaan',
      icon: 'Building2'
    },
    {
      opportunity: 'Platform E-commerce',
      potential: 'Sedang',
      description: 'Penjualan online melalui marketplace',
      icon: 'Smartphone'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Analysis Metrics Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {analysisMetrics?.map((metric, index) => (
          <div key={index} className="bg-card rounded-xl border border-border p-5">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name={metric?.icon} size={24} color="var(--color-primary)" />
              </div>
              <div className="flex-1">
                <h4 className="text-sm font-semibold text-foreground mb-1">{metric?.title}</h4>
                <p className={`text-lg font-bold ${metric?.color} mb-1`}>{metric?.value}</p>
                <p className="text-xs text-muted-foreground">{metric?.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Market Opportunities */}
      <div className="bg-card rounded-xl border border-border p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="Target" size={20} color="var(--color-primary)" />
          Peluang Ekspansi Pasar
        </h3>
        <div className="space-y-4">
          {marketOpportunities?.map((opp, index) => (
            <div key={index} className="flex items-start gap-4 p-4 rounded-lg bg-muted/50 hover:bg-muted transition-colors">
              <div className="w-10 h-10 rounded-lg bg-accent/20 flex items-center justify-center flex-shrink-0">
                <Icon name={opp?.icon} size={20} color="var(--color-accent)" />
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between mb-1">
                  <h4 className="font-medium text-foreground">{opp?.opportunity}</h4>
                  <span className={`text-xs px-2 py-1 rounded-full ${
                    opp?.potential === 'Tinggi' ? 'bg-success/10 text-success' : 'bg-warning/10 text-warning'
                  }`}>
                    {opp?.potential}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground">{opp?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Expansion Readiness Score */}
      <div className="bg-gradient-to-br from-primary/10 to-accent/10 rounded-xl border border-border p-6">
        <div className="flex items-center gap-3 mb-4">
          <Icon name="TrendingUp" size={24} color="var(--color-primary)" />
          <h3 className="text-lg font-semibold text-foreground">Skor Kesiapan Ekspansi</h3>
        </div>
        <div className="flex items-end gap-4">
          <div className="flex-1">
            <div className="h-4 bg-background rounded-full overflow-hidden mb-2">
              <div 
                className="h-full bg-gradient-to-r from-primary to-accent transition-all duration-500"
                style={{ width: '72%' }}
              />
            </div>
            <p className="text-sm text-muted-foreground">
              Berdasarkan diversifikasi pelanggan dan stabilitas kontrak
            </p>
          </div>
          <div className="text-right">
            <p className="text-3xl font-bold text-primary data-text">72</p>
            <p className="text-sm text-muted-foreground">dari 100</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketExpansionAnalysis;